import { useMutation } from "@tanstack/react-query";
import { useAxiosProvider } from "../providers/axios-provider.js";
import "react/jsx-runtime";
import "react";
import "axios";
const deleteBlocker = (axios) => async (referenceId) => {
  await axios.delete(`/api/v2/blockers/${referenceId}`);
};
const useDeleteBlocker = (onSuccess) => {
  const { shiftPlanner } = useAxiosProvider();
  if (!shiftPlanner) {
    throw new Error("shiftPlanner axios instance is not defined");
  }
  const mutation = useMutation({
    mutationFn: (referenceId) => {
      return deleteBlocker(shiftPlanner)(referenceId);
    },
    onSuccess: () => {
      onSuccess == null ? void 0 : onSuccess();
    }
  });
  return mutation;
};
export {
  useDeleteBlocker
};
